export default __webpack_public_path__ + "static/media/full-screen-image-3.92a03538.jpg";